import EventEmitter from "base/EventEmitter";

class AutoComplete extends EventEmitter {
    constructor($input, options = {}) {
        super();
        this.options = $.extend(true, {}, AutoComplete.DEFAULT_OPTIONS, options);

        this.justOpened = false;

        this.$input = $input;
        this.items = [];

        this.buildElement();
        this.bindEvents();

        this.setItems(this.items);
    }

    buildElement() {
        this.$list = (eotwJSXFactory('ul', {class: this.options.baseClass + "__list"}));
        this.$listWrap = (eotwJSXFactory('div', {class: this.options.baseClass}, [this.$list]));

        this.$input.after(this.$listWrap);
    }

    bindEvents() {
        const me = this;

        this.$input.on("focus", () => {
            this.updateItems();
        }).on("blur", () => {
            this.close();
        });
        this.$list.on("focus", "button", () => this.open() || true).on("blur", "button", () => this.close() || true);

        this.$listWrap.on("click", "button", function () {
            me.setValue($(this).parents("li").data("value"));
            me.close(true);
            return false;
        });

        this.$input.on("input", (e) => {
            this.updateItems();
        }).on("keydown", (e) => {
            let focusClass = this.options.baseClass + "__item--focus";
            if (e.which === 38 /*UP*/ || e.which === 40 /*DOWN*/) {
                if (!this.isOpen()) {
                    this.open();
                    return false;
                }
                let direction = e.which === 38 ? -1 /*Up*/ : 1 /*Down*/;
                let current = this.$list.find("." + focusClass).index();

                let targetIndex;
                if (current === -1) {
                    if (direction === 1) {
                        targetIndex = 0;
                    } else {
                        targetIndex = -1;
                    }
                } else {
                    targetIndex = current + direction;
                }

                let $target;
                if (targetIndex < 0) {
                    $target = this.$list.children().last();
                } else if (targetIndex >= this.items.length) {
                    $target = this.$list.children().first();
                } else {
                    $target = this.$list.children().eq(targetIndex);
                }

                this.$list.find("." + focusClass).removeClass(focusClass);
                $target.addClass(focusClass);

                if ($target.length > 0) {
                    let position = $target.position().top;
                    let scrollTop = this.$listWrap.scrollTop();
                    let scrollBottom = scrollTop + this.$listWrap.innerHeight();

                    let top = position + scrollTop;
                    let bottom = top + $target.outerHeight();

                    if (top < scrollTop) {
                        this.$listWrap.scrollTop(top);
                    } else if (bottom > scrollBottom) {
                        this.$listWrap.scrollTop(bottom - this.$listWrap.innerHeight());
                    }
                }

                return false;
            } else if (e.which === 27 /*Esc*/) {
                this.close(true);

                return false;
            } else if (e.which === 13 /*Enter*/) {
                if (this.isOpen() && this.$list.find("." + focusClass).length > 0) {
                    this.$list.find("." + focusClass + " button").click();
                    return false;
                }
            }
        });
    }

    isOpen() {
        return this.$listWrap.is("." + this.options.baseClass + "--shown");
    }

    toggle() {
        if (this.isOpen()) {
            this.close(true);
        } else {
            this.open();
        }
    }

    updateItems(thenOpen = true) {
        let value = this.$input.val();

        if (value === this.lastValue) {
            this.buildList(thenOpen);
            return;
        }

        this.lastValue = value;
        if (value === '' && !this.options.showAll) {
            this.setItems(null, thenOpen);
            return;
        }

        if (this.options.getResults instanceof Function) {
            Promise.resolve(this.options.getResults.call(this, value)).then((items) => {
                this.emit("resultsUpdated", items);
                this.setItems(items, thenOpen);
            });
        } else {
            console.error("Invalid getResults function", this.options);
        }
    }

    open() {
        if (this.closeTimeout) clearTimeout(this.closeTimeout);
        if (this.justOpenedTimeout) clearTimeout(this.justOpenedTimeout);

        if (this.items === null) return;

        this.$listWrap.addClass(this.options.baseClass + "--shown");
        this.justOpened = true;

        this.justOpenedTimeout = setTimeout(() => this.justOpened = false, 500);
    }

    close(immediate = false) {
        if (!this.isOpen()) return;
        if (this.closeTimeout) clearTimeout(this.closeTimeout);
        this.closeTimeout = setTimeout(() => {
            this.$listWrap.removeClass(this.options.baseClass + "--shown")
        }, immediate ? 0 : 50);
    }


    setValue(value) {
        this.emit("selected", value);
        this.close(true);
    }

    setItems(items, thenOpen = false) {
        this.items = items;

        this.buildList(thenOpen);
    }


    buildList(thenOpen = false) {
        if (this.items === null || this.items.length === 0) {
            if (this.options.showEmpty) {
                this.$list.html(this.options.buildEmptyItem.call(this));
            } else {
                this.$list.html("");
                this.close(true);
            }
        } else {
            this.$list.html(this.items.map((item) => {
                let $item = this.options.buildItem.call(this, item);
                $item.data("value", item);
                return $item;
            }));
            if (thenOpen) {
                this.open();
            }
        }
    }
}

AutoComplete.DEFAULT_OPTIONS = {
    baseClass: "autocomplete",
    data: [],
    showEmpty: false,
    showAll: false,
    getResults: function (val) {
        if (val === '') return this.options.data;
        let regex = new RegExp(val, 'i');
        return this.options.data.filter((item) => regex.test(this.options.getTextValue(item)));
    },
    buildItem: function (item) {
        return (
            eotwJSXFactory('li', {class: this.options.baseClass + "__item"}, [
                eotwJSXFactory('button', {type: "button", class: this.options.baseClass + "__btn"}, [this.options.getTextValue(item)])
            ])
        );
    },
    getTextValue: function (item) {
        return item;
    },
    buildEmptyItem: function () {
        return (
            eotwJSXFactory('li', {class: this.options.baseClass + "__item " + this.options.baseClass + "__item--none"}, [
                eotwJSXFactory('span', null, ["No results"])
            ])
        );

    }
};

export default AutoComplete;
